module.exports = {
  LGC: {
    ENDPOINT:'https://data.visua.com/lgc/',
    VERSION: '?version=2'
  },
  GRAPH: {
    ENDPOINT: 'https://graph.visua.com/',
    VERSION: '?version=2'
  },
  API : {
    ENDPOINT: 'https://api.visua.com/'
  },
  HEALTH_STATUS :{
    ERROR: 'UnHealthy'
  },
  STATUS: {
    ONLINE: 'Online'
  },
  COLUMNS: {
    STATUS: 2
  },
  RELOAD_STATUS: {
    WARNING: '<none>',
    ERROR: 'ReloadFailure'
  },
  SUMMARY: {
    STATUS:{
      OK: 'Ok'
    }
  }
}


// WEBPACK FOOTER //
// ./src/config.js